import { render } from "./RowItem.vue?vue&type=template&id=70a0e635&scoped=true"
import script from "./RowItem.vue?vue&type=script&lang=js"
export * from "./RowItem.vue?vue&type=script&lang=js"

import "./RowItem.vue?vue&type=style&index=0&id=70a0e635&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a0e635"]])

export default __exports__